import { bunja } from 'bunja';
import { useBunja } from 'bunja/react';
import { atom, useAtomValue } from 'jotai';

import { i18nBunja } from '@flipster/i18n';
import segment from '@flipster/utils/segment';

import { SegmentPage } from '../misc/segment/segment-page';
import { copyTradingBunja } from '../shared/copy-trading/state';
import { titleKey } from './section/1-header';

export const CopyTradingHomeSegmentView = () => {
  const { viewPayloadAtom } = useBunja(copyTradingHomeSegmentBunja);
  const payload = useAtomValue(viewPayloadAtom);
  if (!payload) return null;
  return <SegmentPage name='copytrading_home_screen_visit' context={payload} />;
};

export const copyTradingHomeSegmentBunja = bunja(() => {
  const { getT } = bunja.use(i18nBunja);
  const t = getT();
  const page_type = 'copytrading_home_screen_visit';
  const { myStatusAtom } = bunja.use(copyTradingBunja);
  const viewPayloadAtom = atom((get) => {
    const status = get(myStatusAtom);
    if (!status) return;
    return {
      copy_started_yn: status.numOngoingCopies > 0,
      master_trader_yn: status.isMaster,
      title: t(titleKey),
    };
  });
  function trackCopyTradingViewCopyActivityClick() {
    segment.track('copytrading_home_button_click_view', {
      page_type,
    });
  }
  function trackCopyTradingCopyButtonClick(nickname: string) {
    segment.track('copytrading_home_copy_button_click', {
      page_type,
      master_nickname: nickname,
    });
  }
  return {
    viewPayloadAtom,
    trackCopyTradingCopyButtonClick,
    trackCopyTradingViewCopyActivityClick,
  };
});
copyTradingHomeSegmentBunja.debugLabel = 'copyTradingHomeSegmentBunja';
